/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_Hip_RInputs */

const en_us2_bodymap_region_hip_r = /** @type {(inputs: Bodymap_Region_Hip_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right hip`)
};

const pt_br2_bodymap_region_hip_r = /** @type {(inputs: Bodymap_Region_Hip_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadril direito`)
};

const es_419_bodymap_region_hip_r = /** @type {(inputs: Bodymap_Region_Hip_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadera derecha`)
};

const pt_pt2_bodymap_region_hip_r = /** @type {(inputs: Bodymap_Region_Hip_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anca direita`)
};

const fr_fr2_bodymap_region_hip_r = /** @type {(inputs: Bodymap_Region_Hip_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanche droite`)
};

const de_de2_bodymap_region_hip_r = /** @type {(inputs: Bodymap_Region_Hip_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechte Hüfte`)
};

const it_it2_bodymap_region_hip_r = /** @type {(inputs: Bodymap_Region_Hip_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anca destra`)
};

/**
* | output |
* | --- |
* | "Right hip" |
*
* @param {Bodymap_Region_Hip_RInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_hip_r = /** @type {((inputs?: Bodymap_Region_Hip_RInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_Hip_RInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_hip_r(inputs)
	if (locale === "es-419") return es_419_bodymap_region_hip_r(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_hip_r(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_hip_r(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_hip_r(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_hip_r(inputs)
	return en_us2_bodymap_region_hip_r(inputs)
});
export { bodymap_region_hip_r as "bodymap.region.hip_r" }